import { ArrowRightIcon } from 'lucide-react';
import { backyardLinks, images } from '../data/site';
import { SiteLink } from './SiteLink';
export function BackyardLiving() {
  return <section aria-labelledby="backyard-heading" className="w-full bg-white" data-id="element-129" data-mp="37zz3q5n8f1pk">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-130" data-mp="3msizumbys8xi">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-131" data-mp="3hz6ohdwapymp">
          <div className="lg:col-span-7" data-id="element-132" data-mp="3vquzteyq0j2m">
            <div className="aspect-[3/2] w-full overflow-hidden rounded-card" data-id="element-133" data-mp="3vtpl18pk67x3">
              <img src={images.backyardLiving} alt="Friends relaxing around a fire table beside a Big Green Egg and a hot tub integrated into the wood deck." className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-134" data-mp="3rphtz4vmofvp" />
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-135" data-mp="26d80fnqphxoy">
            <p className="text-[14px] font-bold uppercase text-ember" data-id="element-136" data-mp="26e9dtyv72w9u">Backyard Living</p>
            <h2 id="backyard-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-137" data-mp="3s5wthxaj39cp">
              Outdoor Living Starts Here.
            </h2>
            <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-138" data-mp="4ycl9w2yb42o">
              Whether you're enjoying a quiet morning with coffee by the lake, grilling for family
              and friends, hosting your son's baseball team or relaxing in the hot tub after a long
              day, the right outdoor furniture transforms your backyard into your favorite place to
              be.
            </p>
            <p className="mt-4 text-[16px] font-bold text-ink" data-id="element-139" data-mp="oooedl76qnlo">
              Featured brands: Polywood, Winston and Big Green Egg Grills
            </p>

            <ul className="mt-5 border-t border-ink/10" data-id="element-140" data-mp="2qfruur3rawe5">
              {backyardLinks.map(link => <li key={link.label} className="border-b border-ink/10" data-id="element-141" data-mp="2ug3bztwwuekv">
                  <SiteLink to={link.href} className="flex min-h-[52px] items-center justify-between gap-3 text-[16.5px] font-medium text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-142" data-mp="1m4qoatepk76">
                    {link.label}
                    <ArrowRightIcon className="h-4 w-4 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-143" data-mp="6lpqsokbbylh" />
                  </SiteLink>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}